import { createContext, useContext } from 'react';

import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

import type { TPaywallContext } from './types';

export const PaywallContext = createContext<TPaywallContext>({
	isOpenPaymentForm: false,
	openPaywall: () => () => undefined,
});

export const usePaywallContext = () => {
	const context = useContext(PaywallContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.PaymentService,
			LoggerMessages.PaywallContextError,
			{}
		);
		throw Error('Paywall context no context Provider');
	}
	return context;
};
